export default __webpack_public_path__ + "static/white-cards-e43ea24d96d00044eaa3fcfde3f8d386.png";